import { useEffect, useState } from 'react';
import { useClient } from 'shared/apollo';
import { GuidanceQuestions } from './GuidanceContent';
import { useGraphQLRequest } from 'shared/auth/hooks/useApiRequest';
import { AllNpoReportQuestions, getAllQuestions } from './api';

export const useReportBuilderQuestions = () => {
  const client = useClient();
  const [questions, setQuestions] = useState<GuidanceQuestions>();
  const [requestQuestionsState, makeQuestionsRequest] = useGraphQLRequest<
    AllNpoReportQuestions
  >();

  useEffect(() => {
    if (!client) return;
    makeQuestionsRequest(getAllQuestions(client));
  }, [makeQuestionsRequest]);

  useEffect(() => {
    if (requestQuestionsState.type !== 'REQUEST_SUCCESS') return;
    const result: GuidanceQuestions = {
      activities: [],
      allocation: [],
      beneficiaries: [],
      budget: [],
      dates: [],
      description: [],
      finalize_report: [],
      custom_questions: [],
      interim_report: [],
      impact_summary: [],
      indicator_details: [],
      location: [],
      narrative: [],
    };
    for (const q of requestQuestionsState.data.allNpoReportQuestions) {
      result[q.section].push(q);
    }
    setQuestions(result);
  }, [setQuestions, requestQuestionsState]);

  return {
    questions,
    requestQuestionsState,
  };
};
